import React from 'react';
import Modal from '../../../client/components/Modal';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import AccountSettings from '../AccountSettings';
import styles from './index.sass';
import banquetLogoPng from '../images/banquet_logo_2x.png';
import banquetLogoSvg from '../images/banquet_logo.svg';
import LargeCloseIconPng from './images/large_close.png';
import LargeCloseIconSvg from './images/large_close.svg';
import CloseIconPng from '../images/button_menu_close.png';
import CloseIconSvg from '../images/button_menu_close.svg';

let isMobile;

class AccountSettingsModal extends React.Component {
  static propTypes = {
    onClose: React.PropTypes.func
  };

  static contextTypes = {
    getUserAgent: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {closingModal: false};
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
    document.body.style.width = '';
    document.body.style.position = '';
  }

  handleOnCloseModal() {
    this.setState({closingModal: true});
    setTimeout(() => {
      this.props.onClose && this.props.onClose();
    }, 200);
  }

  render() {
    isMobile = isMobile || this.context.getUserAgent().isMobile;
    let modalProps = {
      onClose: this.handleOnCloseModal.bind(this),
      closeOnOutsideClick: false,
      className: styles.accountSettingsModal + (this.state.closingModal ? (` ${styles.closing}`) : ''),
      overlayClassName: styles.accountSettingsModalOverlay
    };
    let closeButtonProps = {
      className: styles.closeButton,
      onClick: this.handleOnCloseModal.bind(this)
    };
    let accountSettingsProps = {
      customer: this.props.customer,
      store: this.props.store,
      requestStatus: this.props.requestStatus,
      error: this.props.error
    };

    return (
      <Modal {...modalProps}>
        <button {...closeButtonProps}>
          {isMobile ? <img src={CloseIconPng} srcSet={CloseIconSvg} /> : <img src={LargeCloseIconPng} srcSet={LargeCloseIconSvg} />}
        </button>
        <img className={styles.banquetLogo} src={banquetLogoPng} srcSet={banquetLogoSvg} />
        <AccountSettings {...accountSettingsProps} />
      </Modal>
    );
  }
}

AccountSettingsModal = connectToStores(AccountSettingsModal, [CustomerStore], (context, props) => {
  let customerStore = context.getStore(CustomerStore);
  return {
    customer: customerStore.getCurrentCustomer(),
    requestStatus: customerStore.getCurrentRequestStatus(),
    error: customerStore.getCurrentError()
  };
});

export default AccountSettingsModal;



// WEBPACK FOOTER //
// banquet/components/AccountSettingsModal/index.js